import React from 'react';
import { ApiRequestsContext, ApiRequestsTypes } from '../../../data-catalog-shared';
import { InlineDescriptionEditor } from '../InlineDescriptionEditor';


export interface FieldInlineDescriptionEditorProps {
  readonly canEditDescription: boolean;
  readonly description: string;
  readonly datasourceLuid: string;
  readonly fullyQualifiedFieldName: string;
  readonly fieldType: string;
  readonly afterDescriptionChange?: () => void;
}

export function FieldInlineDescriptionEditor(props: FieldInlineDescriptionEditorProps): JSX.Element {
  const apiRequests = React.useContext(ApiRequestsContext);

  const setDescription = async (inputText: string) => {
    if (props.fieldType === 'HierarchyField') {
      const fieldArgs: ApiRequestsTypes.SetDrillPathFieldDescriptionArgs = {
        fullyQualifiedFieldName: props.fullyQualifiedFieldName,
        datasourceLuid: props.datasourceLuid,
        description: inputText
      };
      return await apiRequests.setDrillPathFieldDescription(fieldArgs);
    }
    const args: ApiRequestsTypes.SetFieldDescriptionArgs = {
      fullyQualifiedFieldName: props.fullyQualifiedFieldName,
      datasourceLuid: props.datasourceLuid,
      description: inputText
    };

    return await apiRequests.setFieldDescription(args);
  };

  return (
    <InlineDescriptionEditor
      canEdit={props.canEditDescription}
      onSave={setDescription}
      initialDescription={props.description}
      afterSave={props.afterDescriptionChange}
    />
  );
}
